var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainContent',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('PageTitle',{attrs:{"title":"Renovar deportista"}})]},proxy:true},{key:"content",fn:function(){return [_c('RenovarBase')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }